/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcquirePrinterLockResponseDto
 */
export interface AcquirePrinterLockResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof AcquirePrinterLockResponseDto
     */
    acquired: boolean;
    /**
     * 
     * @type {string}
     * @memberof AcquirePrinterLockResponseDto
     */
    lockExpiresAt?: string | null;
}

/**
 * Check if a given object implements the AcquirePrinterLockResponseDto interface.
 */
export function instanceOfAcquirePrinterLockResponseDto(value: object): value is AcquirePrinterLockResponseDto {
    if (!('acquired' in value) || value['acquired'] === undefined) return false;
    return true;
}

export function AcquirePrinterLockResponseDtoFromJSON(json: any): AcquirePrinterLockResponseDto {
    return AcquirePrinterLockResponseDtoFromJSONTyped(json, false);
}

export function AcquirePrinterLockResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquirePrinterLockResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'acquired': json['acquired'],
        'lockExpiresAt': json['lockExpiresAt'] == null ? undefined : json['lockExpiresAt'],
    };
}

export function AcquirePrinterLockResponseDtoToJSON(value?: AcquirePrinterLockResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'acquired': value['acquired'],
        'lockExpiresAt': value['lockExpiresAt'],
    };
}

